// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialTransactionCodeSetupState,
    TransactionCodeSetupSchema,
    TransactionCodeSetupFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const TransactionCodeSetup = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [transaction_code_setup, setTransactionCodeSetup] = useState(InitialTransactionCodeSetupState);
    const [formFields, setFormFields] = useState(TransactionCodeSetupFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchoolsByCompanies = async (type) => {
        spinService.on();
        const response = await post(EntityConstants.NOT_IN_TRANSACTION_CODE_SETUP, { type: type, id: id === undefined ? null : id });
        const data = await response.json();
        attachOptions("schools", data);
        spinService.off();
    };

    const getTransactionCodeSetup = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.TRANSACTION_CODE_SETUPS + `/${id}`);
        const data = await response.json();
        setTransactionCodeSetup(data);
        getSchoolsByCompanies(data.type);
        spinService.off();
    };

    const handleValueChange = (e) => {
        if (e.target.name === "type") {
            getSchoolsByCompanies(e.target.value);
        }
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewTransactionCodeSetup = values.id === undefined;
        const url = isNewTransactionCodeSetup ? EntityConstants.TRANSACTION_CODE_SETUPS : EntityConstants.TRANSACTION_CODE_SETUPS + `/${values.id}`;
        const method = isNewTransactionCodeSetup ? post : put;
        const response = await method(url, { transaction_code_setup: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewTransactionCodeSetup ? MessageContants.TRANSACTION_CODE_SETUP_CREATED : MessageContants.TRANSACTION_CODE_SETUP_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        if (id !== undefined) {
            getTransactionCodeSetup(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={transaction_code_setup}
            validationSchema={TransactionCodeSetupSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                handleChange,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={(e) => { handleChange(e); handleValueChange(e); }}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.TRANSACTION_CODE_SETUP_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.TRANSACTION_CODE_SETUP_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

TransactionCodeSetup.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default TransactionCodeSetup;
